import type { SelectDesignTokens, SelectTokenSections } from '@openng/optimus-ui-themes/types/select';

export const root: SelectTokenSections.Root = {
	disabledColor: '{form.field.placeholder.color}',
	placeholderColor: '{surface.200}',
	lg: {
		paddingY: '0.5rem',
	},
};

export default {
	root,
} satisfies SelectDesignTokens;
